// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CountdownClock_container__IVapc{
    position: relative;
    width: calc(100% - 50px);
    padding: 24px 25px;
    border: 1px solid #1F363D1A;
    border-radius: 25px;
    box-shadow: 0 3px 12px 0 #00000012;
}
.CountdownClock_header__axsLU{
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    color: #40798C;
    font-family: 'Gotham Bold', serif;
}
.CountdownClock_endOn__l7RcB, .CountdownClock_endAt__k-C3r{
    display: flex;
    justify-content: center;
    padding: 12px 20px;
    color: #40798C;
    background-color: #70A9A11A;
    border: 1px solid #70A9A11A;
    border-radius: 25px;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
}
.CountdownClock_endOn__l7RcB{
    margin-left: 10px;
}
@media(max-width: 1080px){
    .CountdownClock_container__IVapc{
        display: flex;
        align-items: center;
        padding: 24px 24px;
    }
    .CountdownClock_header__axsLU{
        margin-bottom: 0;
    }
    .CountdownClock_remainingTime__nIK9k, .CountdownClock_endAt__k-C3r{
        margin-left: auto;
        padding-right: 30px;
    }
}
@media(max-width: 840px){
    .CountdownClock_container__IVapc{
        display: block;
        padding: 24px 25px;
    }
    .CountdownClock_header__axsLU{
        margin-bottom: 15px;
    }
    .CountdownClock_remainingTime__nIK9k, .CountdownClock_endAt__k-C3r{
        margin-left: 0;
    }
}
@media(max-width: 490px){
    .CountdownClock_remainingTime__nIK9k{
        padding-right: 0;
    }
}
@media(max-width: 435px){
    .CountdownClock_header__axsLU{
        display: block;
    }
    .CountdownClock_endOn__l7RcB{
        width: 200px;
        margin-top: 12px;
        margin-left: 0;
        padding: 12px 0;
    }
}
.CountdownClock_days__dGFiT, .CountdownClock_hours__c9ClZ, .CountdownClock_minutes__Q-ops, .CountdownClock_seconds__-Tfly{
    display: inline-block;
    padding: 12px 20px;
    color: #40798C;
    background-color: #70A9A11A;
    font-size: 14px;
    font-family: 'Gotham Medium', serif;
    border: 1px solid #70A9A11A;
    border-radius: 25px;
}
@media(max-width: 490px){
    .CountdownClock_days__dGFiT, .CountdownClock_hours__c9ClZ, .CountdownClock_minutes__Q-ops, .CountdownClock_seconds__-Tfly{
        padding: 12px 12px;
    }
}
.CountdownClock_divider__7Jge7{
    margin-left: 5px;
    margin-right: 5px;
    color: #40798C;
    font-family: 'Gotham Bold', serif;
}
.CountdownClock_pencil__7Fjne{
    position: absolute;
    right: 28px;
    top: 28px;
    height: 16px;
    width: 16px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/fundraiser/CountdownClock.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,2BAA2B;IAC3B,mBAAmB;IACnB,kCAAkC;AACtC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,iCAAiC;AACrC;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,mCAAmC;AACvC;AACA;IACI,iBAAiB;AACrB;AACA;IACI;QACI,aAAa;QACb,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,gBAAgB;IACpB;IACA;QACI,iBAAiB;QACjB,mBAAmB;IACvB;AACJ;AACA;IACI;QACI,cAAc;QACd,kBAAkB;IACtB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,cAAc;IAClB;IACA;QACI,YAAY;QACZ,gBAAgB;QAChB,cAAc;QACd,eAAe;IACnB;AACJ;AACA;IACI,qBAAqB;IACrB,kBAAkB;IAClB,cAAc;IACd,2BAA2B;IAC3B,eAAe;IACf,mCAAmC;IACnC,2BAA2B;IAC3B,mBAAmB;AACvB;AACA;IACI;QACI,kBAAkB;IACtB;AACJ;AACA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,iCAAiC;AACrC;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,YAAY;IACZ,WAAW;IACX,eAAe;AACnB","sourcesContent":[".container{\n    position: relative;\n    width: calc(100% - 50px);\n    padding: 24px 25px;\n    border: 1px solid #1F363D1A;\n    border-radius: 25px;\n    box-shadow: 0 3px 12px 0 #00000012;\n}\n.header{\n    display: flex;\n    align-items: center;\n    margin-bottom: 15px;\n    color: #40798C;\n    font-family: 'Gotham Bold', serif;\n}\n.endOn, .endAt{\n    display: flex;\n    justify-content: center;\n    padding: 12px 20px;\n    color: #40798C;\n    background-color: #70A9A11A;\n    border: 1px solid #70A9A11A;\n    border-radius: 25px;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n}\n.endOn{\n    margin-left: 10px;\n}\n@media(max-width: 1080px){\n    .container{\n        display: flex;\n        align-items: center;\n        padding: 24px 24px;\n    }\n    .header{\n        margin-bottom: 0;\n    }\n    .remainingTime, .endAt{\n        margin-left: auto;\n        padding-right: 30px;\n    }\n}\n@media(max-width: 840px){\n    .container{\n        display: block;\n        padding: 24px 25px;\n    }\n    .header{\n        margin-bottom: 15px;\n    }\n    .remainingTime, .endAt{\n        margin-left: 0;\n    }\n}\n@media(max-width: 490px){\n    .remainingTime{\n        padding-right: 0;\n    }\n}\n@media(max-width: 435px){\n    .header{\n        display: block;\n    }\n    .endOn{\n        width: 200px;\n        margin-top: 12px;\n        margin-left: 0;\n        padding: 12px 0;\n    }\n}\n.days, .hours, .minutes, .seconds{\n    display: inline-block;\n    padding: 12px 20px;\n    color: #40798C;\n    background-color: #70A9A11A;\n    font-size: 14px;\n    font-family: 'Gotham Medium', serif;\n    border: 1px solid #70A9A11A;\n    border-radius: 25px;\n}\n@media(max-width: 490px){\n    .days, .hours, .minutes, .seconds{\n        padding: 12px 12px;\n    }\n}\n.divider{\n    margin-left: 5px;\n    margin-right: 5px;\n    color: #40798C;\n    font-family: 'Gotham Bold', serif;\n}\n.pencil{\n    position: absolute;\n    right: 28px;\n    top: 28px;\n    height: 16px;\n    width: 16px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `CountdownClock_container__IVapc`,
	"header": `CountdownClock_header__axsLU`,
	"endOn": `CountdownClock_endOn__l7RcB`,
	"endAt": `CountdownClock_endAt__k-C3r`,
	"remainingTime": `CountdownClock_remainingTime__nIK9k`,
	"days": `CountdownClock_days__dGFiT`,
	"hours": `CountdownClock_hours__c9ClZ`,
	"minutes": `CountdownClock_minutes__Q-ops`,
	"seconds": `CountdownClock_seconds__-Tfly`,
	"divider": `CountdownClock_divider__7Jge7`,
	"pencil": `CountdownClock_pencil__7Fjne`
};
export default ___CSS_LOADER_EXPORT___;
